/**
 * DataTrans PM Popup
 */

define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const user = require('user');
    const DepositMethodView = require('portlets/cashier/deposit/deposit.method.view');
    const PaymentButtonMethodView = require('portlets/cashier/deposit/special/paymentbutton-deposit.method.view');
    const BaseReplacerView = require('common/base.replacer.view');

    module.exports = BaseReplacerView.extend({
        className: 'swiss-lightbox-popup',

        render: function() {
            const amountValue = $('.deposit__ApplePayDT .field_name_amount input').val();
            this.$el.html(this.tmpl('deposit.method.popup.view', {
                amount: amountValue,
                currencyCode: user.get('currencyCode')
            }));

            this.checkPaymentButton()
                .then(() => this._paymentButtonView.supported
                    ? DepositMethodView.prototype.render.apply(this, arguments)
                    : this.$el.parents('.payment-method').remove());

            return this;
        },

        checkPaymentButton: function() {
            return new Promise(function(resolve, reject) {
                this._paymentButtonView = new PaymentButtonMethodView({
                    form: this.form,
                    model: this.model
                });

                this._paymentButtonView.depositAndRender().then(() => resolve(), () => reject());
            }.bind(this));
        }
    }, {
        nameOfReplacers: [
            'DATATRANS_PM_POPUP'
        ]
    });
});
